<template>
  <div v-if="doCover" class="cover-layer">
    <div class="notice-container">如需在手机上查看数据<br>建议您登录电脑升级为付费版</div>
  </div>
</template>

<style lang="less" scoped>
  .cover-layer {
    background-color: rgba(1,1,1,0.6);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .notice-container {
      border-radius: 5px;
      padding: 5%;
      position: fixed;
      text-align: center;
      width: 60%;
      top: 30%;
      left: 20%;
      background-color: rgba(255,255,255,0.9);
    }
  }
</style>

<script>
  export default {
    props: {
      doCover: Boolean
    }
  }
</script>



// WEBPACK FOOTER //
// LxmCover.vue?1ac3bda1